'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import LandingNav from '@/app/components/LandingNav';

const HIDE_PREFIXES = [
  '/tenant-dashboard',
  '/super-admin',
  '/client-portal',
  '/documents',
  '/employees',
  '/client-companies',
  '/renewals',
  '/pay',
  '/invite',
  '/access-denied',
  '/auth',
  '/api',
];

function shouldShowPublicHeader(pathname: string) {
  if (!pathname) return false;
  if (pathname === '/_not-found') return false;
  return !HIDE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export default function PublicHeaderMount() {
  const pathname = usePathname();
  if (!shouldShowPublicHeader(pathname)) return null;
  return <LandingNav />;
}
